import { render, staticRenderFns } from "./ChapterConfiguratorImages.vue?vue&type=template&id=3a6cdbb4&"
import script from "./ChapterConfiguratorImages.vue?vue&type=script&lang=js&"
export * from "./ChapterConfiguratorImages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports